import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: 'WHAT IS ENGINEERING INTELLIGENCE?',
  a: 'Engineering intelligence (or engineering management platforms) are tools that aggregate data from your software development lifecycle (Git, Jira, CI/CD, incidents) and combine it with developer surveys to provide visibility into team health, delivery speed, and business alignment.'
}, {
  q: 'ARE GIT METRICS ENOUGH?',
  a: "Generally, no. Early tools focused solely on lines of code or commit counts, which are easily gamed and don't reflect true productivity. Modern tools focus on DORA metrics (delivery speed/stability), SPACE framework, and qualitative DevEx surveys to get a holistic picture."
}, {
  q: 'WILL THESE TOOLS BE USED TO SURVEIL DEVELOPERS?',
  a: 'This is the biggest risk of implementing EI tools. The best platforms (and the best engineering leaders) explicitly design their implementations to measure team-level performance, not individual stack-ranking. Tools like Waydev, Swarmia, and DX are particularly vocal about team-first, anti-surveillance approaches.'
}, {
  q: 'DORA VS SPACE VS DEVEX?',
  a: 'DORA measures delivery performance (speed and stability). SPACE is a broader framework that includes satisfaction, performance, activity, communication, and efficiency. DevEx (Developer Experience) focuses on removing friction and improving the day-to-day workflow of engineers. The best teams use a combination of these.'
}, {
  q: 'BUILD VS BUY?',
  a: 'Many teams start by building internal dashboards using Jira APIs and GitHub webhooks. However, maintaining these pipelines, handling edge cases (like squash merges), and building survey infrastructure quickly becomes a full-time job. Buying is usually more cost-effective for teams over 50 engineers.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-base relative" data-id="element-112">
      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:pl-24 lg:pr-8" data-id="element-113">
        <div className="mb-16 font-mono" data-id="element-114">
          <div className="text-lime text-xs tracking-widest mb-4" data-id="element-115">
            §06 / QUERY_INDEX
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-ink uppercase tracking-tight mb-6" data-id="element-116">
            FAQ Log
          </h2>
        </div>

        <div className="max-w-3xl font-mono text-sm" data-id="element-117">
          <div className="hairline-t" data-id="element-118">
            {faqs.map((faq, i) => <div key={i} className="hairline-b" data-id="element-119">
                <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full py-6 flex items-start justify-between text-left focus:outline-none group hover:bg-ink/5 px-4 -mx-4 transition-colors" aria-expanded={openIndex === i} data-id="element-120">
                  <span className="font-bold text-ink group-hover:text-lime transition-colors pr-8" data-id="element-121">
                    <span className="text-ink/30 mr-4" data-id="element-122">Q{i + 1}.</span>
                    {faq.q}
                  </span>
                  <span className="text-lime shrink-0 mt-0.5" data-id="element-123">
                    {openIndex === i ? '[-]' : '[+]'}
                  </span>
                </button>
                <AnimatePresence data-id="element-124">
                  {openIndex === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-125">
                      <div className="pb-8 text-ink/60 leading-relaxed pl-10 pr-4" data-id="element-126">
                        <span className="text-indigo-400 mr-2" data-id="element-127">A.</span>
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}